import React, { useEffect, useState } from 'react';
import './PromoWelcome.scss';
import rofusLogo from 'images/footer/spillemyndigheden.png';
import betLogo from 'images/bet25sport_logo.svg';
import tilladelseLogo from 'images/footer/spillemyndigheden.png';
import centerLudomani from 'images/center_ludomani.png';
import rofus from 'images/newRofusLogo.png';
import stopspillet from 'images/footer/stopspillet.svg';
import clockIcon from 'images/clock.svg';
import { Link } from 'react-router';

const PromoWelcome = (props) => {
    const [items, setItems] = useState([]);
    const [pending, setPending] = useState(true);

    const localhost = window.location.hostname === 'localhost';
    const siteName = localhost
        ? window.location.hostname
        : window.location.hostname
              .split('.')
              .slice(-2, -1)[0]
              .slice(0, -2);
    const imgHost = 'https://cms.bet25.dk';

    const getProjectData = () => {
        return {
            loginLink: '/sport/log-ind',
            signLink: '/sport/opret-konto',
            projectName: 'Bet25 Sport',
            link: '/sport',
            logo: betLogo,
            color: '#1c3e60',
        };
    };

    const projectData = getProjectData();

    const buildRequestUrl = () => {
        let urlParam = window.location.pathname.split('/').slice(-1);
        let host = 'cms.bet25.dk';
        let hostName = siteName;

        if (localhost) {
            host = 'cms.bet25.dk';
            urlParam = 'velkommen';
            hostName = 'bet';
        }

        return `https://${host}/rest/landing-page/get-page?url=${urlParam}&hostName=${hostName}_`;
    };

    const clock = () => {
        let date = new Date();
        let mins = ('0' + date.getMinutes()).slice(-2);
        let hours = date.getHours();

        return (
            <div className="clockWrapper">
                {hours}
                <span className="clockIconSeparator">:</span>
                {mins}
                <img className="clockIcon" src={clockIcon} alt="clock" />
            </div>
        );
    };

    const Loader = (props) => {
        return (
            <div id="spinner" style={{ background: props.bg }}>
                <div className="loader-wrapper">
                    <img src={props.imgSrc} alt={props.imgAlt} width="170px" />
                    <div className="spinner">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        fetch(buildRequestUrl())
            .then((res) => res.json())
            .then(
                (result) => {
                    if (result.success) {
                        setItems(result.data);
                        setInterval(() => setPending(false), 500);
                    } else {
                        window.location = projectData.link + 404;
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
    }, []);
    return (
        <>
            {pending ? (
                <Loader
                    imgSrc={projectData.logo}
                    imgAlt={projectData.projectName}
                    bg={projectData.color}
                />
            ) : (
                <div className="promoWelcomeWrapper">
                    <div className="contentWrapper">
                        <header>
                            <div className="topMenu">
                                <a
                                    href="https://www.spillemyndigheden.dk/"
                                    className="topMenuLogo"
                                >
                                    <img src={rofusLogo} alt="Rofus" />
                                </a>
                                <p className="topMenuText">
                                    18+
                                    <span className="topMenuSeparator">|</span>
                                    <a href="https://www.stopspillet.dk/">
                                        <img
                                            src={stopspillet}
                                            alt="StopSpillet.dk"
                                            className="topMenuStopSpillet"
                                        />
                                    </a>
                                    <span className="topMenuSeparator">|</span>
                                    <a href="https://intercom.help/25syv/da/articles/3493600-ansvarligt-spil-25syv">
                                        Ansvarligt spil
                                    </a>
                                    <span className="topMenuSeparator">|</span>
                                    <a href="https://www.rofus.nu/">
                                        Udeluk dig via ROFUS
                                    </a>
                                </p>
                            </div>
                            {clock()}
                        </header>
                        <div
                            className="main"
                            style={{
                                backgroundImage:
                                    'url(' +
                                    imgHost +
                                    items.background_image +
                                    ')',
                            }}
                        >
                            <nav>
                                <div className="logoContainer">
                                    <Link to={'/'}>
                                        <img
                                            src={
                                                items.logo
                                                    ? imgHost + items.logo
                                                    : projectData.logo
                                            }
                                            alt={projectData.projectName}
                                            className="logo"
                                        />
                                    </Link>
                                </div>
                                <div className="loginArea">
                                    <button
                                        className="opretBtn"
                                        onClick={() =>
                                            (window.location.href =
                                                projectData.signLink)
                                        }
                                    >
                                        Opret
                                    </button>
                                    <button
                                        className="loginBtn"
                                        onClick={() =>
                                            (window.location.href =
                                                projectData.loginLink)
                                        }
                                    >
                                        Log ind
                                    </button>
                                </div>
                            </nav>

                            <div className="mainCenter">
                                <h1
                                    className="mainTitle"
                                    dangerouslySetInnerHTML={{
                                        __html: items.header,
                                    }}
                                />
                                <div className="mainButtonBlock">
                                    <a
                                        href={items.cta_button_link}
                                        className="buttonCTA"
                                    >
                                        {items.cta_button_text}
                                    </a>
                                    <a
                                        href={items.button_link}
                                        className="buttonSecondary"
                                    >
                                        {items.button_text}
                                    </a>
                                </div>
                                <div className="mainTextBlock">
                                    <p
                                        className="text"
                                        dangerouslySetInnerHTML={{
                                            __html: items.terms,
                                        }}
                                    />
                                </div>
                                <ul className="stepsBlock">
                                    <li>
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={{
                                                __html: items.step1,
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={{
                                                __html: items.step2,
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={{
                                                __html: items.step3,
                                            }}
                                        />
                                    </li>
                                </ul>
                                <ul className="stepsMobile">
                                    <li>
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={{
                                                __html: items.step1,
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={{
                                                __html: items.step2,
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={{
                                                __html: items.step3,
                                            }}
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <footer>
                        <div className="footerTop">
                            <div className="footerTopTextBlock">
                                <div
                                    className="footerTopText"
                                    dangerouslySetInnerHTML={{
                                        __html: items.terms2,
                                    }}
                                />
                            </div>
                            <div className="footerTopCenter">
                                <div className="footerTopCenterItem">
                                    <img
                                        src={
                                            items.logo
                                                ? imgHost + items.logo
                                                : projectData.logo
                                        }
                                        alt={projectData.projectName}
                                        className="footerLogo"
                                    />
                                    <h3>Udbydes af 25syv</h3>
                                    <p>
                                        25syv A/S, Mariane Thomsens Gade 2F,
                                        8000 Aarhus C.
                                    </p>
                                </div>
                                <div className="footerDGABlock">
                                    <a
                                        href="https://www.spillemyndigheden.dk/"
                                        target="_blank"
                                    >
                                        <img
                                            height="80px"
                                            width="80px"
                                            src={tilladelseLogo}
                                            alt="Tilladelse fra og under tilsyn af Spillemyndigheden."
                                        />
                                        <div className="footerDGABlockTitle">
                                            Tilladelse fra og under tilsyn af
                                            Spillemyndigheden.
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="footerBottom">
                            <div className="footerBottomCenter">
                                <div className="footerBottomSupport">
                                    <div className="footerBottomSupportItem">
                                        <a href="https://www.stopspillet.dk/">
                                            <img src={stopspillet} alt="" />
                                        </a>
                                        <a
                                            href="tel:70-22-28-25"
                                            className="footerBottomSupportBtn"
                                        >
                                            Ring til 70 22 28 25
                                        </a>
                                    </div>
                                    <div className="footerBottomSupportItem">
                                        <a href="https://ludomani.dk/">
                                            <img src={centerLudomani} alt="" />
                                        </a>
                                        <a
                                            href="https://ludomani.dk/"
                                            className="footerBottomSupportBtn"
                                        >
                                            Test dig selv
                                        </a>
                                    </div>
                                    <div className="footerBottomSupportItem">
                                        <a href="https://www.rofus.nu/">
                                            <img
                                                style={{
                                                    height: '20px',
                                                }}
                                                src={rofus}
                                                alt=""
                                            />
                                        </a>
                                        <a
                                            href="https://www.rofus.nu/"
                                            className="footerBottomSupportBtn"
                                        >
                                            Opret registrering
                                        </a>
                                    </div>
                                </div>
                                <div className="footerBottomCopyright">
                                    <div className="footerBottomCopyrightItem">
                                        © {new Date().getFullYear()} 25syv A/S.{' '}
                                        <br />
                                        Alle rettigheder forbeholdes.
                                    </div>
                                    <div className="footerBottomCopyrightItem">
                                        <div className="footerBottomAgeRestrict">
                                            18+
                                        </div>
                                        Spil kan være vanedannende, spil altid
                                        med omtanke.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            )}
        </>
    );
};

export default PromoWelcome;
